import StatusLayout from '../model/entity/StatusLayout';
import * as types from '../constants/ActionTypes';

const initialState: StatusLayout = new StatusLayout();


export default (statusLayout: StatusLayout = initialState, action: Object) => {
  if (action.type === types.SET_STATUS_LAYOUT) {
    return {
      ...action.statusLayout,
    };
  }
  return statusLayout;
};
